import { render, staticRenderFns } from "./ReviewsMarquee.vue?vue&type=template&id=4f208d0a&scoped=true"
import script from "./ReviewsMarquee.vue?vue&type=script&lang=ts"
export * from "./ReviewsMarquee.vue?vue&type=script&lang=ts"
import style0 from "./ReviewsMarquee.vue?vue&type=style&index=0&id=4f208d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f208d0a",
  null
  
)

export default component.exports